import React, { useState } from "react";

const BRAND_COLOR = "#1a3f6b";
const BRAND_ACCENT_COLOR = "#10b981";
const GRAY_DARK_COLOR = "#334155";

export default function FAQ({ items, isMobile }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section
      style={{
        background: "#f8fafc",
        padding: isMobile ? "3.5rem 1.5rem" : "5rem 2rem",
      }}
    >
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <h2
          style={{
            textAlign: "center",
            fontSize: isMobile ? "1.8rem" : "2.4rem",
            fontWeight: 800,
            color: BRAND_COLOR,
            marginBottom: "0.75rem",
            letterSpacing: "-0.02em",
          }}
        >
          Frequently Asked Questions
        </h2>
        <p
          style={{
            textAlign: "center",
            color: GRAY_DARK_COLOR,
            fontSize: "1.05rem",
            lineHeight: 1.7,
            marginBottom: "2.5rem",
            opacity: 0.7,
          }}
        >
          Everything you need to know about Vendorleads.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
          {items.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                  overflow: "hidden",
                  transition: "box-shadow 0.2s",
                  boxShadow: isOpen
                    ? "0 4px 16px rgba(0,0,0,0.06)"
                    : "0 1px 3px rgba(0,0,0,0.04)",
                }}
              >
                <button
                  onClick={() => toggle(idx)}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "1rem",
                    padding: isMobile ? "1rem 1.25rem" : "1.25rem 1.5rem",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                >
                  <span
                    style={{
                      fontSize: isMobile ? "0.95rem" : "1.05rem",
                      fontWeight: 600,
                      color: BRAND_COLOR,
                      lineHeight: 1.4,
                    }}
                  >
                    {item.question}
                  </span>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "28px",
                      height: "28px",
                      borderRadius: "50%",
                      background: isOpen
                        ? BRAND_ACCENT_COLOR
                        : "rgba(16,185,129,0.1)",
                      color: isOpen ? "#fff" : BRAND_ACCENT_COLOR,
                      fontSize: "1.1rem",
                      fontWeight: 600,
                      flexShrink: 0,
                      transition: "transform 0.25s, background 0.25s, color 0.25s",
                      transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                    }}
                  >
                    +
                  </span>
                </button>
                <div
                  style={{
                    maxHeight: isOpen ? "500px" : "0px",
                    overflow: "hidden",
                    transition: "max-height 0.3s ease",
                  }}
                >
                  <p
                    style={{
                      padding: isMobile
                        ? "0 1.25rem 1rem 1.25rem"
                        : "0 1.5rem 1.25rem 1.5rem",
                      margin: 0,
                      fontSize: "0.95rem",
                      color: GRAY_DARK_COLOR,
                      lineHeight: 1.7,
                    }}
                  >
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
